import React from "react";
import Box from "../layout/Box";

class BoxEditor extends React.Component {

    focus = () => {
        //this.box.focus();
    }

    hide = () => {
        //this.box.hide();
    }

    render() {
        return <Box ref={(el) => this.box = el} {...this.props}>
            {this.props.children}
        </Box>;
    }

}

export default BoxEditor;